import { render } from "./IconShare.vue?vue&type=template&id=79974396"
import script from "./IconShare.vue?vue&type=script&lang=js"
export * from "./IconShare.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__